import { ClientProfileFormValues, TUserProfileInfo } from 'types/state';
import { M8UserProfile, M8UserProfileUpdate } from 'services/production/types';
import { normalizeOrgStaffCount } from 'services/production/utils/normalizeOrgStaffCount';
import { PartnerProfileFormValues } from 'types/partnerProfileFormTypes';

export const normalizeUserProfileInfo = (info: TUserProfileInfo) => ({
  toM8UserProfile: (): Partial<M8UserProfile> => ({
    firstName: info.firstName,
    lastName: info.lastName,
    middleName: info.middleName,
    position: info.position,
    organization: info.company,
    companySize: info.orgStaffCount
      ? normalizeOrgStaffCount(info.orgStaffCount).toCompanySize()
      : 'UNDEFINED',
    phone: info.phone,
  }),
  toM8UserProfileUpdate: (): M8UserProfileUpdate => {
    if (info.location === null) {
      throw new TypeError();
    }

    return {
      firstName: info.firstName,
      lastName: info.lastName,
      middleName: info.middleName,
      position: info.position,
      organization: info.company,
      companySize: info.orgStaffCount
        ? normalizeOrgStaffCount(info.orgStaffCount).toCompanySize()
        : 'UNDEFINED',
      phone: info.phone,
      resident: info.resident,
      country: info.location,
    };
  },
  toClientProfileFormValues(): ClientProfileFormValues {
    return {
      firstName: info.firstName,
      lastName: info.lastName,
      middleName: info.middleName,
      position: info.position,
      phone: info.phone,
      location: info.location,
      company: info.company,
    };
  },
  toPartnerProfileFormValues(): PartnerProfileFormValues {
    return {
      avatar: null,
      firstName: info.firstName,
      middleName: info.middleName,
      lastName: info.lastName,
      phone: info.phone,
      city: '',
      country: null,
      details: '',
    };
  },
});
